<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right">
      <toolbar :key="'tp-toolbar-' + toolbarKey" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" style="width: 100%; margin-top: 20px;" height="100%">
        <el-table-column prop="GroupName" label="分组名称" width="" align="center" header-align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="CampusName" label="校区" width="" align="center" header-align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="班牌数" width="80" align="center" header-align="center">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" class="cell-link" @click="openTerminalDialog(scope.row)">
              {{ scope.row.TerminalCount }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="巡检教师" width="120" align="center" header-align="center">
          <template slot-scope="scope">
            <span class="cell-link-wrap" @click="openStaffDialog(scope.row)">
              <el-tag v-if="scope.row.AllTeachersEnabled" type="warning" size="small" class="cell-link-tag">全校教职工</el-tag>
              <el-link v-else type="primary" :underline="false" class="cell-link">{{ scope.row.StaffCount }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center" header-align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.Enabled ? 'success' : 'danger'" size="small">
              {{ scope.row.Enabled ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="SortOrder" label="排序" width="" align="center" header-align="center"></el-table-column>
        <el-table-column min-width="1" align="center" header-align="center"></el-table-column>
        <el-table-column label="操作" width="180" align="center" header-align="center">
          <template slot-scope="scope">
            <div class="op-cell">
              <div class="op-row">
                <el-button size="mini" type="primary" @click="openTerminalDialog(scope.row)">班牌</el-button>
                <el-button size="mini" type="warning" @click="openStaffDialog(scope.row)">人员</el-button>
              </div>
              <div class="op-row">
                <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="handleDel(scope.row)">删除</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <div class="pagination-container">
        <el-pagination layout="total,prev,pager,next" @current-change="handleCurrentChange"
          :current-page="page" :page-size="pageSize" :total="total" style="float: right"></el-pagination>
      </div>

      <el-dialog :title="dialogTitle" :visible.sync="editFormVisible" width="520px" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="110px" :rules="editFormRules" ref="editForm">
          <el-form-item label="分组名称" prop="GroupName">
            <el-input v-model="editForm.GroupName" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="所属校区">
            <el-select v-model="editForm.CampusId" placeholder="请选择校区" style="width: 100%"
              @change="handleEditCampusChange">
              <el-option label="全校通用" :value="0"></el-option>
              <el-option v-for="item in campusOptions" :key="item.Id || item.id"
                :label="item.Name || item.name" :value="item.Id != null ? item.Id : item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="巡检教师">
            <span class="form-tip">
              <i class="el-icon-warning-outline"></i>
              可勾选全部教职工，或指定多名巡检教师
            </span>
            <el-checkbox v-model="editAllTeachersUi" style="display: block; margin: 8px 0;">全部教职工有效（无需指定）</el-checkbox>
            <el-select v-model="editFormTeacherIds" multiple filterable
              :placeholder="editAllTeachersUi ? '已设为全部教职工有效' : '请选择教职工'"
              :disabled="editAllTeachersUi" :loading="teacherLoading" style="width: 100%">
              <el-option v-for="item in teacherOptions" :key="item.Id || item.id"
                :label="item.TeacherName || item.teacherName" :value="item.Id != null ? item.Id : item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序">
            <el-input-number v-model="editForm.SortOrder" :min="0" :max="9999"></el-input-number>
          </el-form-item>
          <el-form-item label="启用">
            <el-switch v-model="editForm.Enabled"></el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click="editSubmit" :loading="editLoading">确定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="配置班牌" :visible.sync="terminalDialogVisible" width="560px"
        custom-class="teacher-patrol-terminal-dialog" append-to-body :close-on-click-modal="false">
        <div class="terminal-transfer-shell">
          <el-transfer v-model="selectedTerminalIds" :data="terminalOptions" filterable
            :titles="['可选班牌', '已选班牌']" :props="{ key: 'key', label: 'label' }"
            :render-content="renderTerminalTransferItem"></el-transfer>
        </div>
        <div slot="footer">
          <el-button @click="terminalDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveTerminals" :loading="terminalSaving">保存</el-button>
        </div>
      </el-dialog>

      <el-dialog title="配置巡检教师" :visible.sync="staffDialogVisible" width="520px" :close-on-click-modal="false">
        <el-checkbox v-model="staffAllTeachersUi" style="margin-bottom: 12px;">全部教职工有效（无需指定）</el-checkbox>
        <el-select v-model="selectedTeacherIds" multiple filterable
          :placeholder="staffAllTeachersUi ? '已设为全部教职工有效' : '请选择教职工'"
          style="width: 100%" :disabled="staffAllTeachersUi" :loading="teacherLoading">
          <el-option v-for="item in teacherOptions" :key="item.Id || item.id"
            :label="item.TeacherName || item.teacherName" :value="item.Id != null ? item.Id : item.id"></el-option>
        </el-select>
        <div slot="footer">
          <el-button @click="staffDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveStaff" :loading="staffSaving">保存</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import {
  getTeacherPatrolGroupListPage,
  addTeacherPatrolGroup,
  editTeacherPatrolGroup,
  deleteTeacherPatrolGroup,
  getTeacherPatrolGroupTerminals,
  saveTeacherPatrolGroupTerminals,
  getTeacherPatrolGroupStaff,
  saveTeacherPatrolGroupStaff,
  getTeacherPatrolTerminalOptions,
  loadTeacherPatrolCampusOptions,
  clearTeacherPatrolListTable,
  onTeacherPatrolSchoolChange,
  resolveTeacherPatrolSchoolIdFromTreeNode,
  getTeacherPatrolCurrentSchoolId
} from "@/api/teacherPatrol";
import { toDeptId, treeNodeDeptId } from '../../utils/deptCascaderProps';
import { getTeacherMasterList } from '../../api/modules/personnel';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from "../../components/DepartmentPane";

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: { groupName: "", campusId: null },
      searchList: [
        { label: "分组名称", key: "groupName" },
        { label: "校区", key: "campusId", type: "select", clearable: true, options: [] }
      ],
      buttonList: [],
      users: [],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      DepartmentId: 0,
      toolbarKey: 0,
      schoolId: 0,
      campusOptions: [],
      editFormVisible: false,
      editLoading: false,
      dialogTitle: "新增分组",
      editForm: {
        Id: 0,
        SchoolId: 0,
        CampusId: 0,
        GroupName: "",
        AllTeachersEnabled: false,
        Enabled: true,
        SortOrder: 0
      },
      editFormRules: {
        GroupName: [{ required: true, message: "请输入分组名称", trigger: "blur" }]
      },
      terminalDialogVisible: false,
      terminalOptions: [],
      selectedTerminalIds: [],
      currentGroupId: 0,
      currentGroupCampusId: 0,
      terminalSaving: false,
      staffDialogVisible: false,
      staffAllTeachers: false,
      editFormTeacherIds: [],
      selectedTeacherIds: [],
      teacherOptions: [],
      teacherLoading: false,
      staffSaving: false
    };
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
  computed: {
    editAllTeachersUi: {
      get() {
        return this.editForm.AllTeachersEnabled;
      },
      set(val) {
        this.$set(this.editForm, "AllTeachersEnabled", !!val);
        if (val) {
          this.editFormTeacherIds = [];
        } else {
          this.ensureTeacherOptionsLoaded(this.editForm.CampusId);
        }
      }
    },
    staffAllTeachersUi: {
      get() {
        return this.staffAllTeachers;
      },
      set(val) {
        this.staffAllTeachers = !!val;
        if (val) {
          this.selectedTeacherIds = [];
        } else {
          this.ensureTeacherOptionsLoaded(this.currentGroupCampusId);
        }
      }
    }
  },
  methods: {
    callFunction(item) {
      if (typeof item.search === "object") {
        this.filters = item.search;
      }
      this[item.Func].apply(this, item);
    },
    async treeNodeClick(data, node) {
      const nodeId = treeNodeDeptId(data);
      onTeacherPatrolSchoolChange(this, nodeId);
      this.schoolId = resolveTeacherPatrolSchoolIdFromTreeNode(node, nodeId);
      this.editFormVisible = false;
      this.terminalDialogVisible = false;
      this.staffDialogVisible = false;
      await this.loadCampusOptions();
      this.handleQuery();
    },
    async loadCampusOptions() {
      await loadTeacherPatrolCampusOptions(this, this.DepartmentId);
    },
    handleQuery() {
      this.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    async getList() {
      if (!this.DepartmentId) {
        clearTeacherPatrolListTable(this);
        return;
      }
      this.listLoading = true;
      try {
        const para = {
          departmentId: this.DepartmentId,
          campusId: this.filters.campusId || 0,
          groupName: this.filters.groupName || "",
          page: this.page,
          intPageSize: this.pageSize
        };
        const res = await getTeacherPatrolGroupListPage(para);
        if (res.data.success) {
          this.users = res.data.response.data || [];
          this.total = res.data.response.dataCount || 0;
          if (this.users.length > 0) {
            this.schoolId = this.users[0].SchoolId;
          }
        } else {
          clearTeacherPatrolListTable(this);
        }
      } finally {
        this.listLoading = false;
      }
    },
    async fetchTeacherList(deptId, campusId) {
      const para = {
        page: 1,
        intPageSize: 9999,
        DepartmentId: deptId
      };
      const campusKey = toDeptId(campusId);
      if (campusKey) {
        para.CampusId = campusKey;
      }
      const res = await getTeacherMasterList(para);
      if (res.data && res.data.response) {
        return res.data.response;
      }
      return [];
    },
    async loadTeacherOptions(campusId) {
      if (!this.DepartmentId) return;
      this.teacherLoading = true;
      try {
        this.teacherOptions = await this.fetchTeacherList(this.DepartmentId, campusId) || [];
      } catch (e) {
        this.teacherOptions = [];
      } finally {
        this.teacherLoading = false;
      }
    },
    ensureTeacherOptionsLoaded(campusId) {
      if (this.teacherOptions && this.teacherOptions.length > 0) return;
      this.loadTeacherOptions(campusId);
    },
    handleEditCampusChange(val) {
      this.editFormTeacherIds = [];
      this.loadTeacherOptions(val);
    },
    handleAdd() {
      if (!this.DepartmentId) {
        this.$message.warning("请先在左侧选择学校");
        return;
      }
      this.loadCampusOptions();
      this.loadTeacherOptions(0);
      this.dialogTitle = "新增分组";
      this.editForm = {
        Id: 0,
        SchoolId: getTeacherPatrolCurrentSchoolId(this),
        CampusId: 0,
        GroupName: "",
        AllTeachersEnabled: false,
        Enabled: true,
        SortOrder: 0
      };
      this.editFormTeacherIds = [];
      this.editFormVisible = true;
    },
    async handleEdit(row) {
      this.loadCampusOptions();
      const campusId = toDeptId(row.CampusId);
      await this.loadTeacherOptions(campusId);
      this.dialogTitle = "编辑分组";
      this.editForm = {
        ...row,
        CampusId: campusId,
        AllTeachersEnabled: !!row.AllTeachersEnabled
      };
      this.$set(this.editForm, "AllTeachersEnabled", !!row.AllTeachersEnabled);
      this.editFormTeacherIds = [];
      if (row.Id > 0) {
        const staffRes = await getTeacherPatrolGroupStaff(row.Id);
        if (staffRes.data.success) {
          const data = staffRes.data.response || {};
          this.$set(this.editForm, "AllTeachersEnabled", !!(data.allTeachersEnabled != null ? data.allTeachersEnabled : data.AllTeachersEnabled));
          this.editFormTeacherIds = (data.staff || []).map(s => s.TeacherMasterId || s.teacherMasterId);
        }
      }
      this.editFormVisible = true;
    },
    async saveGroupStaff(groupId) {
      if (!groupId) return;
      await saveTeacherPatrolGroupStaff({
        GroupId: groupId,
        AllTeachersEnabled: !!this.editForm.AllTeachersEnabled,
        TeacherMasterIds: this.editForm.AllTeachersEnabled ? [] : this.editFormTeacherIds
      });
    },
    editSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (!valid) return;
        if (!this.editForm.AllTeachersEnabled && (!this.editFormTeacherIds || this.editFormTeacherIds.length === 0)) {
          this.$message.warning("请勾选全部教职工，或至少选择一名巡检教师");
          return;
        }
        this.editLoading = true;
        try {
          const payload = { ...this.editForm };
          delete payload.AllTeachersEnabled;
          const api = payload.Id > 0 ? editTeacherPatrolGroup : addTeacherPatrolGroup;
          if (!payload.SchoolId) {
            payload.SchoolId = getTeacherPatrolCurrentSchoolId(this);
          }
          const res = await api(payload);
          if (res.data.success) {
            const groupId = payload.Id > 0 ? payload.Id : Number(res.data.response);
            await this.saveGroupStaff(groupId);
            this.$message.success(res.data.msg || "保存成功");
            this.editFormVisible = false;
            this.getList();
          }
        } finally {
          this.editLoading = false;
        }
      });
    },
    handleDel(row) {
      this.$confirm("确认删除该分组？", "提示", { type: "warning" }).then(async () => {
        const res = await deleteTeacherPatrolGroup(row.Id);
        if (res.data.success) {
          this.$message.success("删除成功");
          this.getList();
        }
      }).catch(() => {});
    },
    buildTerminalOption(t) {
      const terminalId = t.TerminalId || t.terminalId || "";
      const terminalName = t.TerminalName || t.terminalName || "";
      const dept = t.DepartmentName || t.departmentName || "";
      const mainText = dept || terminalName || terminalId;
      let subText = "";
      if (dept && terminalId && terminalId !== dept) {
        subText = terminalId;
      } else if (!dept && terminalName && terminalId && terminalName !== terminalId) {
        subText = terminalId;
      }
      return {
        key: t.Id || t.id,
        label: [mainText, subText, terminalName, terminalId].filter(Boolean).join(" "),
        mainText: mainText,
        subText: subText
      };
    },
    renderTerminalTransferItem(h, option) {
      const mainText = option.mainText || option.label || "";
      const subText = option.subText || "";
      const children = [
        h("div", { class: "terminal-transfer-item__main" }, mainText)
      ];
      if (subText) {
        children.push(h("div", { class: "terminal-transfer-item__sub" }, subText));
      }
      return h("div", { class: "terminal-transfer-item" }, children);
    },
    async openTerminalDialog(row) {
      this.currentGroupId = row.Id;
      this.terminalDialogVisible = true;
      const [optRes, bindRes] = await Promise.all([
        getTeacherPatrolTerminalOptions({ departmentId: this.DepartmentId, campusId: row.CampusId || 0 }),
        getTeacherPatrolGroupTerminals(row.Id)
      ]);
      if (optRes.data.success) {
        this.terminalOptions = (optRes.data.response || []).map(t => this.buildTerminalOption(t));
      }
      if (bindRes.data.success) {
        this.selectedTerminalIds = (bindRes.data.response || []).map(t => t.CplateTerminalId);
      }
    },
    async saveTerminals() {
      this.terminalSaving = true;
      try {
        const res = await saveTeacherPatrolGroupTerminals({
          GroupId: this.currentGroupId,
          CplateTerminalIds: this.selectedTerminalIds
        });
        if (res.data.success) {
          this.$message.success("保存成功");
          this.terminalDialogVisible = false;
          this.getList();
        }
      } finally {
        this.terminalSaving = false;
      }
    },
    async openStaffDialog(row) {
      this.currentGroupId = row.Id;
      this.currentGroupCampusId = toDeptId(row.CampusId);
      this.staffDialogVisible = true;
      this.teacherLoading = true;
      try {
        await this.loadTeacherOptions(this.currentGroupCampusId);
        const staffRes = await getTeacherPatrolGroupStaff(row.Id);
        if (staffRes.data.success) {
          const data = staffRes.data.response || {};
          this.staffAllTeachers = !!(data.allTeachersEnabled != null ? data.allTeachersEnabled : data.AllTeachersEnabled);
          this.selectedTeacherIds = (data.staff || []).map(s => s.TeacherMasterId || s.teacherMasterId);
        }
      } finally {
        this.teacherLoading = false;
      }
    },
    async saveStaff() {
      if (!this.staffAllTeachers && (!this.selectedTeacherIds || this.selectedTeacherIds.length === 0)) {
        this.$message.warning("请勾选全部教职工，或至少选择一名巡检教师");
        return;
      }
      this.staffSaving = true;
      try {
        const res = await saveTeacherPatrolGroupStaff({
          GroupId: this.currentGroupId,
          AllTeachersEnabled: this.staffAllTeachers,
          TeacherMasterIds: this.staffAllTeachers ? [] : this.selectedTeacherIds
        });
        if (res.data.success) {
          this.$message.success("保存成功");
          this.staffDialogVisible = false;
          this.getList();
        }
      } finally {
        this.staffSaving = false;
      }
    }
  }
};
</script>

<style scoped>
.pagination-container {
  margin-top: 16px;
  overflow: hidden;
}
.op-cell {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 4px 0;
}
.op-row {
  display: flex;
  justify-content: center;
  gap: 6px;
}
.op-row .el-button {
  margin-left: 0;
  min-width: 72px;
  padding: 7px 14px;
}
.cell-link-wrap {
  cursor: pointer;
  display: inline-block;
}
.cell-link-tag {
  cursor: pointer;
}
.cell-link {
  font-weight: 500;
}
.form-tip {
  display: flex;
  align-items: center;
  color: #E6A23C;
  font-size: 13px;
  margin-bottom: 4px;
}
.form-tip i {
  margin-right: 4px;
}
</style>

<style>
/* 配置班牌弹窗：默认上下布局 */
.teacher-patrol-terminal-dialog {
  width: 560px !important;
  max-width: 96vw;
  border-radius: 8px;
  overflow: hidden;
}
.teacher-patrol-terminal-dialog .el-dialog__header {
  padding: 16px 20px 12px;
  border-bottom: 1px solid #ebeef5;
}
.teacher-patrol-terminal-dialog .el-dialog__body {
  padding: 16px 20px;
  background: #fafbfc;
}
.teacher-patrol-terminal-dialog .el-dialog__footer {
  padding: 12px 20px 16px;
  border-top: 1px solid #ebeef5;
}
.terminal-transfer-shell .el-transfer {
  display: flex !important;
  flex-direction: column !important;
  align-items: stretch !important;
  width: 100% !important;
  gap: 8px;
}
.terminal-transfer-shell .el-transfer-panel {
  width: 100% !important;
  flex: none !important;
  border-radius: 8px;
  border-color: #e4e7ed;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}
.terminal-transfer-shell .el-transfer-panel__header {
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  padding: 0 12px;
}
.terminal-transfer-shell .el-transfer-panel__header .el-checkbox {
  line-height: 40px;
}
.terminal-transfer-shell .el-transfer-panel__filter {
  margin: 10px 12px;
  width: auto;
}
.terminal-transfer-shell .el-transfer-panel__filter .el-input__inner {
  border-radius: 6px;
}
.terminal-transfer-shell .el-transfer__buttons {
  flex-shrink: 0;
  display: flex !important;
  flex-direction: row !important;
  justify-content: center;
  align-self: center;
  gap: 10px;
  padding: 6px 14px;
  margin: 2px 0;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 20px;
}
.terminal-transfer-shell .el-transfer__button {
  margin: 0 !important;
  width: 36px;
  height: 36px;
  padding: 0 !important;
}
.terminal-transfer-shell .el-transfer__button:first-child {
  margin-bottom: 0 !important;
}
.terminal-transfer-shell .el-transfer-panel__body {
  height: 280px;
}
.terminal-transfer-shell .el-transfer-panel__list,
.terminal-transfer-shell .el-transfer-panel__list.is-filterable {
  height: 220px;
  padding: 4px 0;
}
.terminal-transfer-shell .el-transfer-panel__empty {
  color: #c0c4cc;
  font-size: 13px;
}
/* 宽屏（≥1400px）：左右并排 */
@media (min-width: 1400px) {
  .teacher-patrol-terminal-dialog {
    width: 920px !important;
  }
  .terminal-transfer-shell .el-transfer {
    flex-direction: row !important;
    align-items: stretch !important;
    justify-content: center;
    width: auto !important;
    margin: 0 auto;
    gap: 0;
  }
  .terminal-transfer-shell .el-transfer-panel {
    width: 380px !important;
  }
  .terminal-transfer-shell .el-transfer__buttons {
    flex-direction: column !important;
    gap: 8px;
    padding: 0 14px;
    margin: 0;
    background: transparent;
    border: none;
    border-radius: 0;
  }
  .terminal-transfer-shell .el-transfer-panel__body {
    height: 400px;
  }
  .terminal-transfer-shell .el-transfer-panel__list,
  .terminal-transfer-shell .el-transfer-panel__list.is-filterable {
    height: 340px;
  }
}
/* 列表项：卡片式分行，避免重叠与蓝条错位 */
.teacher-patrol-terminal-dialog .el-transfer-panel__item.el-checkbox {
  display: flex !important;
  align-items: flex-start !important;
  height: auto !important;
  min-height: 44px;
  margin: 0 8px 6px !important;
  padding: 8px 10px 8px 8px !important;
  line-height: normal !important;
  border-radius: 6px;
  border: 1px solid transparent;
  box-sizing: border-box;
  transition: background 0.15s, border-color 0.15s;
}
.teacher-patrol-terminal-dialog .el-transfer-panel__item.el-checkbox:hover {
  background: #f5f7fa;
  border-color: #e4e7ed;
}
.teacher-patrol-terminal-dialog .el-transfer-panel__item .el-checkbox__input {
  position: static !important;
  margin-top: 3px;
  flex-shrink: 0;
}
.teacher-patrol-terminal-dialog .el-transfer-panel__item.el-checkbox .el-checkbox__label {
  position: static !important;
  overflow: visible !important;
  white-space: normal !important;
  text-overflow: clip !important;
  line-height: 1.5 !important;
  height: auto !important;
  flex: 1;
  min-width: 0;
  padding-left: 10px !important;
  display: block !important;
  box-sizing: border-box;
}
.teacher-patrol-terminal-dialog .terminal-transfer-item {
  width: 100%;
}
.teacher-patrol-terminal-dialog .terminal-transfer-item__main {
  font-size: 13px;
  font-weight: 500;
  color: #303133;
  line-height: 1.5;
  word-break: break-word;
}
.teacher-patrol-terminal-dialog .terminal-transfer-item__sub {
  margin-top: 3px;
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
  font-family: Consolas, Monaco, monospace;
  word-break: break-all;
}
</style>
